// extracted by mini-css-extract-plugin
module.exports = {"statContainer":"Stat_statContainer__uNpvC","value":"Stat_value__vfUXa","label":"Stat_label__RMOQC"};